import moment from 'moment';
export function isValid(slot, duration){
  let e = slot.end.clone();
  e.subtract(duration, 'minutes');
  return e >= moment();
}